module.exports = __webpack_public_path__ + "img/sklogo.152965fe.png";